module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/staff4-27236bb2e7e53c4b055b33824454b371.jpg";